const rotas: Array<any> = [
  {
    denied: ['PLANO_CALCULADORA'],
    icone: 'home',
    texto: 'Home',
    url: '/home',
    viewName: 'home',
    keyAuthorized: 'home',
    isAuthorized: false,
  },
  {
    denied: ['PLANO_CALCULADORA'],
    icone: 'add_box',
    texto: 'Produção',
    url: '/producao',
    viewName: 'producao',
    keyAuthorized: 'producao',
    isAuthorized: false,
  },
  {
    denied: ['PLANO_CALCULADORA'],
    icone: 'assignment',
    texto: 'Recebimento',
    url: '/recebimento',
    viewName: 'recebimento',
    keyAuthorized: 'recebimento',
    isAuthorized: false,
  },
  {
    denied: ['PLANO_CALCULADORA'],
    icone: 'assessment',
    texto: 'Relatório',
    url: '/relatorio/fonte-pagadora',
    viewName: 'relatorio',
    keyAuthorized: 'relatorio',
    isAuthorized: false,
  },
  {
    hideOnMobile: true,
    icone: 'receipt',
    texto: 'Agendamento',
    url: '/agendamento-medico',
    viewName: 'agendamento-medico',
    keyAuthorized: 'agendamento-medico',
    isAuthorized: false,
  },
  {
    icone: 'check',
    texto: 'Aprovação',
    url: '/v2/backoffice/aprovacao',
    externalLink: true,
    viewName: 'aprovacao',
    badgeKey: 'aprovacao',
    permissao: 'agendamento.backoffice.fluxoDeAprovacao.listar',
  },
  {
    hideOnMobile: true,
    icone: 'work',
    texto: 'Backoffice',
    url: '/backoffice',
    viewName: 'backoffice-agendamento',
    keyAuthorized: 'backoffice',
    isAuthorized: false,
  },
  {
    hideOnMobile: true,
    icone: 'smartphone',
    texto: 'Calculadora',
    url: '/calculadora',
    viewName: 'calculadora',
    keyAuthorized: 'calculadora',
    isAuthorized: false,
  },
  {
    hideOnMobile: true,
    icone: 'account_box',
    texto: 'Perfil',
    url: '/perfil',
    viewName: 'perfil',
    keyAuthorized: 'perfil',
    isAuthorized: true,
  },
]

export default rotas
